var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4034 15.6221L28.6554 2.0445C28.8766 1.81795 29 1.51697 29 1.20397C29 0.890974 28.8766 0.58999 28.6554 0.363441L28.6404 0.348822C28.5331 0.238614 28.404 0.150859 28.261 0.0908918C28.1179 0.0309248 27.9638 9.53674e-07 27.8081 9.53674e-07C27.6524 9.53674e-07 27.4983 0.0309248 27.3552 0.0908918C27.2121 0.150859 27.083 0.238614 26.9758 0.348822L14.4975 13.1346L2.02422 0.348822C1.91697 0.238614 1.78788 0.150859 1.64479 0.0908918C1.50171 0.0309248 1.34763 9.53674e-07 1.19192 9.53674e-07C1.0362 9.53674e-07 0.88212 0.0309248 0.739037 0.0908918C0.595953 0.150859 0.46686 0.238614 0.359613 0.348822L0.344639 0.363441C0.123411 0.58999 -1.90735e-06 0.890974 -1.90735e-06 1.20397C-1.90735e-06 1.51697 0.123411 1.81795 0.344639 2.0445L13.5966 15.6221C13.7131 15.7415 13.8533 15.8366 14.0086 15.9016C14.1639 15.9665 14.3311 16 14.5 16C14.6689 16 14.8361 15.9665 14.9914 15.9016C15.1467 15.8366 15.2869 15.7415 15.4034 15.6221Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/down arrow.4ba0b60bdb7f7cb2b347ca85abaed03c.svg";
export { ForwardRef as ReactComponent };